import React from 'react';
import PropTypes from 'prop-types';
import {
  DialogTitle,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Button,
  Grid,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
} from '@material-ui/core';
import FolderIcon from '@material-ui/icons/Folder';

function VerifyActionsDialog(props) {
  const content = (props.verified !== null)
    ? <List>
        <ListItem>
          <ListItemIcon>
            <FolderIcon />
          </ListItemIcon>
          <ListItemText primary={`Total verified: ${props.verified.total} actions.`}/>
        </ListItem>
        <ListItem>
          <ListItemIcon>
            <FolderIcon />
          </ListItemIcon>
          <ListItemText primary={`Build: ${props.verified.build} actions verified.`} secondary={`${props.verified.fixedBuild} fixed.`}/>
        </ListItem>
        <ListItem>
          <ListItemIcon>
            <FolderIcon />
          </ListItemIcon>
          <ListItemText primary={`Destroy: ${props.verified.destroy} actions verified.`} secondary={`${props.verified.fixedDestroy} fixed.`}/>
        </ListItem>
    </List>
    : <DialogContentText id="alert-dialog-description">
        {'All actions from first built block will compared with blockchain. It may take a while, depends on number of actions.'}
      </DialogContentText>;
  return (
    <Dialog
      open={props.open}
      onClose={(!props.verification) ? props.handleClose : null}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{`Do you want to verify all actions for Tower-${props.ethId}?`}</DialogTitle>
      <DialogContent>
        {
          (!props.verification)
            ? content
            : <Grid container align="center" justify="center">
                <CircularProgress />
              </Grid>
        }
      </DialogContent>
      <DialogActions>
        {
          (props.verified === null)
          && <Button onClick={props.handleVerify} variant="contained" color="secondary" disabled={props.verification}>
              Verify
            </Button>
        }
        <Button onClick={props.handleClose} variant="contained" color="primary" disabled={props.verification} autoFocus>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}

VerifyActionsDialog.propTypes = {
  open: PropTypes.bool,
  ethId: PropTypes.number,
  verification: PropTypes.bool.isRequired,
  handleVerify: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
  verified: PropTypes.object,
};

export default VerifyActionsDialog;
